import { SecurityService } from './../../core/services/security.service';
import { Component, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../app.service';
import { ListPageBase } from '../../shared/components/list-page-base/list-page-base';
import { ActivityListItem } from '../../shared/models/activity/activity-list-item';
import { RequestsService } from '../../shared/services/requests.service';
import { LookupService } from '../../shared/services/lookup.service';
import { KeyValueObject } from '../../shared/models/core/KeyValueObject';
import { CompositeFilterDescriptor, DataSourceRequestState, FilterDescriptor, isCompositeFilterDescriptor } from '@progress/kendo-data-query';
import { from, fromEvent, interval, Subject, Subscription } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, tap, filter, takeUntil } from 'rxjs/operators';
import { StatePersistingService } from '../../shared/services/state-persisting.service';
import { GridSettings } from '../../shared/models/grid/grid-settings';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { DialogService } from '@progress/kendo-angular-dialog';
import { NotificationService } from '../../core/services/notification.service';
import { CheckboxColumnComponent, ColumnBase, ColumnComponent, ColumnVisibilityChangeEvent, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { UserFiltersService } from '../../shared/services/user-filters.service';
import { UserFilter } from '../../shared/models/user-filter/user-filter';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestNotificationTypeService } from '../../shared/services/request-notification-type.service';
import { RequestNotificationType } from '../../shared/models/request/request-notification-type';
import { ContragentType } from '../../shared/enums';
import { environment } from '../../../environments/environment';
import { ColumnSettings } from '../../shared/models/grid/column-settings';
import { ActivitiesService } from '../../shared/services/activities.service';
import { IntlService } from '@progress/kendo-angular-intl';
import { UserFilterType } from '../../shared/enums/user-filter-type.enum';
import {UsersService} from "../../admin/users/users.service";
import {InitTypesService} from "../../shared/services/init-types.service";
import {RequestStatusesService} from "../../shared/services/request-statuses.service";
import {RequestStatusMspAliasGroupsService} from "../../shared/services/request-status-msp-alias-groups.service";
import {ActivityStatusesService} from "../../shared/services/activity-statuses.service";
import {RequestAttributesService} from "../../shared/services/request-attributes.service";
import {RequestPrioritiesService} from "../../shared/services/request-priorities.service";
import {AttachmentTypesService} from "../../shared/services/attachment-types.service";
import {RegionsService} from "../../shared/services/regions.service";
import {MerchantsService} from "../../categories/merchants/merchants.service";
import {AgreementsService} from "../../shared/services/agreements.service";
import {CategoryServicesService} from "../../shared/services/category-services.service";
import {ServiceCategoriesService} from "../../shared/services/service-categories.service";
import {ServiceTypesService} from "../../shared/services/service-types.service";
import {ServiceModesService} from "../../shared/services/service-modes.service";
import {ServiceCentersService} from "../../shared/services/service-centers.service";
import {ActivityTypesService} from "../../shared/services/activity-types.service";
import {RequestTypeService} from "../../shared/services/request-type.service";
import { RolesService } from '../../admin/roles';
import { ExportExcelFromGridService } from '../../shared/services/export-excel-from-grid.service';
import { IdleService } from '../../shared/services/idle.service';

@Component({
	selector: 'activity-list',
	templateUrl: './list.page.html',
	styleUrls: [
		'../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'./list.page.scss'],
	encapsulation: ViewEncapsulation.None,
	//providers: [IdleService]
})
export class ActivitiesListPage extends ListPageBase<ActivityListItem> implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('filterAllInput') filterAllInput: ElementRef;
	@ViewChild('userFiltersModal') userFiltersModal: any;
	@ViewChild('fileInput') fileInput: any;
	@ViewChild("requestsGrid") requestsGrid: GridComponent;

	activityListSubscription: Subscription = null;

	isIdle = false;

	requestTypes: KeyValueObject[] = [];
	serviceCenters: KeyValueObject[] = [];
	gridSelectedRequests: ActivityListItem[] = [];
	userFilters: UserFilter[] = [];
	notificationTypes: RequestNotificationType[] = [];

	reconciliations: KeyValueObject[] = new Array(new KeyValueObject(1, "Да"), new KeyValueObject(0, "Нет"));

	isMap: boolean = false;
	isMapSwitcherOn: boolean = false;
	isGroupClick: boolean = false;

	public requestsGridGridSelectedCallback = (args) => args.dataItem;

	lastFilterText = '';
	public dataGenerating = false;
	public loadingFinancialReconciliation: boolean = false;
	public setDefaultFiltersIsInProgress: number[] = [];
	public removeFiltersIsInProgress: number[] = [];

	private readonly _refreshTime: number;
	private _lastRefreshTime?: Date = null;

	private _destroy$ = new Subject<boolean>();

	throttle = 300;
	scrollDistance = 1;
	selectedTab = 1;
	selectedRequestStatus = 12;
	selectedDate = 'today';
	selectedOrder = null;
	showTomorrow = false;
	showDays = [];
	delaySearch = null;

	toggledAccordions: Map<number, boolean> = new Map();
	alwaysToggled = false;

	constructor(
		private sanitizer: DomSanitizer,
		protected appService: AppService,
		router: Router,
		private route: ActivatedRoute,
		private modalService: NgbModal,
		protected dataService: ActivitiesService,
		protected requestsService: RequestsService,
		protected persistingService: StatePersistingService,
		private lookupService: LookupService,
		protected dialogService: DialogService,
		protected intl: IntlService,
		protected notificationService: NotificationService,
		protected exportExcelFromGridService: ExportExcelFromGridService,
		private userFiltersService: UserFiltersService,
		private securityService: SecurityService,
		public usersDataService: UsersService,
		public initTypesService: InitTypesService,
		public requestStatusesService: RequestStatusesService,
		public requestStatusMspAliasGroupsService: RequestStatusMspAliasGroupsService,
		public activityStatusesService: ActivityStatusesService,
		public requestAttributesService: RequestAttributesService,
		public requestPrioritiesService: RequestPrioritiesService,
		public attachmentTypesService: AttachmentTypesService,
		public regionsService: RegionsService,
		public merchantsService: MerchantsService,
		public agreementsService: AgreementsService,
		public categoryServicesService: CategoryServicesService,
		public serviceCategoriesService: ServiceCategoriesService,
		public serviceTypesService: ServiceTypesService,
		public serviceModesService: ServiceModesService,
		public serviceCentersService: ServiceCentersService,
		public activityTypesService: ActivityTypesService,
		public requestTypeDataService: RequestTypeService,
		private requestNotificationTypeService: RequestNotificationTypeService,
		protected rolesDataService: RolesService,
		//private idleService: IdleService
	) {
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		this.groupedKey = 'createdDateGroupValue';
		appService.pageTitle = 'Активности';
		this._refreshTime = this._getMsTime(environment.requestListRefreshTime);
		this.alwaysToggled = localStorage.getItem('alwaysToggled') === 'true';
		this.filtersBlockCollapsedStorageKey = 'activitiesListFiltersBlockCollapsed';
		this.restoreFiltersBlockCollapsedState();
	}

	public loadData(state: DataSourceRequestState = this.gridSettings.state): void {
		this.loading = true;

		var visibleColumnNames = this.gridSettings.columnsConfig.filter(x => !x.hidden).map(x => x.field);

		this.setGridSettingsState(this.gridSettings);

		if (this.activityListSubscription !== null)
			this.activityListSubscription.unsubscribe();

		this.activityListSubscription = this.dataService.activityList(state, visibleColumnNames).subscribe(lvm => {
			this.processListItems(lvm.data);
			this.listViewModel = lvm;
			this.groupedData = this.groupedByKey;
			this.loading = false;
		});
	}

	public columnColor(statusColorCode: string, slaColorCode: string): SafeStyle {
		if (slaColorCode) {
			return this.sanitizer.bypassSecurityTrustStyle(slaColorCode);
		}

		return this.sanitizer.bypassSecurityTrustStyle(statusColorCode);
	}

	public rowClass(context: RowClassArgs) {
		if (context.dataItem.hoursToDeadline) {

			let splitHours: number = 0;
			let hours: number = 0;
			let minutes: number = 0;
			let splitDays: number = 0;
			let days: number = 0;

			if (context.dataItem.hoursToDeadline.includes(".")) {
				splitDays = context.dataItem.hoursToDeadline.split(".");
				days = parseInt(splitDays[0]);
			} else {
				splitHours = context.dataItem.hoursToDeadline.split(":");
				hours = parseInt(splitHours[0]);
				minutes = parseInt(splitHours[1]);
			}

			if ((days < 0) || (hours < -3 || (hours === -3 && minutes > 0))) {
				return {
					'cursor-pointer': true,
					'red-text': true
				};
			} else {
				return {
					'cursor-pointer': true
				};
			}

		} else {
			return {
				'cursor-pointer': true
			};
		}
	}

	filterChange(): void {
		this.gridSelectedRequests = [];
	}

	public enableSaveGridSettings: boolean = true;

	gridSettingsStorageKey: string = 'activity-grid-settings-v3';
	gridSettingsFilterStorageKey: string = 'activity-grid-settings-filter-v3';

	public gridSettingsFilter: GridSettings = {
		state: {
			skip: 0,
			take: 25,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'requestIdStr',
				title: '№ заявки',
				filter: 'string',
				filterable: true,
				width: 150,
				hidden: false
			},
			{
				orderIndex: 1,
				field: 'activityNumber',
				title: '№ активности',
				filter: 'string',
				filterable: true,
				width: 150,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'requestTspAddress',
				title: 'Адрес ТСП',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'createdDateLocal',
				title: 'Дата создания активности',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'planStartDateLocal',
				title: 'Согласованная дата визита',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: false
			},
			{
				orderIndex: 5,
				field: 'performerUserName',
				title: 'Исполнитель  по активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'performerUserId'
			},
			{
				orderIndex: 6,
				field: 'statusName',
				title: 'Состояние активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'statusId'
			},
			{
				orderIndex: 7,
				field: 'serviceCenterName',
				title: 'Филиал',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'serviceCenterId'
			},
			{
				orderIndex: 8,
				field: 'finishDateLocal',
				title: 'Дата завершения активности',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: false
			},
			{
				orderIndex: 9,
				field: 'finishActivityComment',
				title: 'Комментарий по закрытию активности',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 10,
				field: 'requestCustomerContragentName',
				title: 'Клиент',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'requestCustomerContragentId'
			},
			{
				orderIndex: 11,
				field: 'merchantRegionName',
				title: 'Регион объекта обслуживания',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'merchantRegionId'
			},
			////////////////Опциональные столбцы////////////////
			{
				orderIndex: 12,
				field: 'requestStateUpdateDateLocal',
				title: 'Дата изменения состояния',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 350,
				hidden: true
			},
			{
				orderIndex: 13,
				field: 'requestCreatedDateLocal',
				title: 'Дата создания заявки',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 250,
				hidden: true
			},
			{
				orderIndex: 14,
				field: 'activityTypeName',
				title: 'Тип активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'activityTypeId'
			},
			{
				orderIndex: 15,
				field: 'requestInitTypeName',
				title: 'Источник заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'requestInitTypeId'
			},
			{
				orderIndex: 16,
				field: 'description',
				title: 'Описание заявки',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 17,
				field: 'requestPriorityName',
				title: 'Приоритет заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				filterField: 'requestPriorityId',
				hidden: true
			},
			{
				orderIndex: 18,
				field: 'requestStatusName',
				title: 'Статус заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'requestStatusId'
			},
			{
				orderIndex: 19,
				field: 'requestTypeName',
				title: 'Тип заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				filterField: 'requestTypeId',
				hidden: true,
			},
			{
				orderIndex: 20,
				field: 'requestServiceNames',
				title: 'Услуги',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'requestServiceId'
			}
		]
	};

	public gridSettings: GridSettings = {
		state: {
			skip: 0,
			take: 25,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'requestIdStr',
				title: '№ заявки',
				filter: 'string',
				filterable: true,
				width: 150,
				hidden: false
			},
			{
				orderIndex: 1,
				field: 'activityNumber',
				title: '№ активности',
				filter: 'string',
				filterable: true,
				width: 150,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'requestTspAddress',
				title: 'Адрес ТСП',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'createdDateLocal',
				title: 'Дата создания активности',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 280,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'planStartDateLocal',
				title: 'Согласованная дата визита',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 5,
				field: 'performerUserName',
				title: 'Исполнитель по активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'performerUserId'
			},
			{
				orderIndex: 6,
				field: 'statusName',
				title: 'Состояние активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'statusId'
			},
			{
				orderIndex: 7,
				field: 'serviceCenterName',
				title: 'Филиал',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'serviceCenterId'
			},
			{
				orderIndex: 8,
				field: 'finishDateLocal',
				title: 'Дата завершения активности',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 9,
				field: 'finishActivityComment',
				title: 'Комментарий по закрытию активности',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: false
			},
			{
				orderIndex: 10,
				field: 'requestCustomerContragentName',
				title: 'Клиент',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: false,
				filterField: 'requestCustomerContragentId'
			},
			{
				orderIndex: 11,
				field: 'merchantRegionName',
				title: 'Регион объекта обслуживания',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'merchantRegionId'
			},
			////////////////Опциональные столбцы////////////////
			{
				orderIndex: 12,
				field: 'requestStateUpdateDateLocal',
				title: 'Дата изменения состояния',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 13,
				field: 'requestCreatedDateLocal',
				title: 'Дата создания заявки',
				filter: 'date',
				format: 'dd.MM.yyyy HH:mm',
				filterable: true,
				width: 280,
				hidden: true
			},
			{
				orderIndex: 14,
				field: 'activityTypeName',
				title: 'Тип активности',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'activityTypeId'
			},
			{
				orderIndex: 15,
				field: 'requestInitTypeName',
				title: 'Источник заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'requestInitTypeId'
			},
			{
				orderIndex: 16,
				field: 'description',
				title: 'Описание заявки',
				filter: 'string',
				filterable: true,
				width: 300,
				hidden: true
			},
			{
				orderIndex: 17,
				field: 'requestPriorityName',
				title: 'Приоритет заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				filterField: 'requestPriorityId',
				hidden: true
			},
			{
				orderIndex: 18,
				field: 'requestStatusName',
				title: 'Статус заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'requestStatusId'
			},
			{
				orderIndex: 19,
				field: 'requestTypeName',
				title: 'Тип заявки',
				filter: 'lookup',
				filterable: true,
				width: 300,
				filterField: 'requestTypeId',
				hidden: true,
			},
			{
				orderIndex: 20,
				field: 'requestServiceNames',
				title: 'Услуги',
				filter: 'lookup',
				filterable: true,
				width: 300,
				hidden: true,
				filterField: 'requestServiceId'
			},
			{
				orderIndex: 20,
				field: 'overallPlanTime',
				title: 'Плановое время',
				filter: 'string',
				filterable: false,
				width: 300,
				hidden: true
			}
		]
	};

	onListPageInit(): void {
		this.lookupService.getData("request-types", null).subscribe(data => this.requestTypes = data);
		this.lookupService.getData("service-centers", null).subscribe(data => this.serviceCenters = data);
		this.requestNotificationTypeService.getTypes().subscribe(data => this.notificationTypes = data);

		this.loadUserFilters(null);

		function enumToMap(enumeration: any): Map<string, number> {
			const map = new Map<string, number>();
			for (let key in enumeration) {
				//TypeScript does not allow enum keys to be numeric
				if (!isNaN(Number(key))) continue;

				const val = enumeration[key] as number;

				//TypeScript does not allow enum value to be null or undefined
				if (val !== undefined && val !== null)
					map.set(key, val);
			}

			return map;
		}
	}

	loadUserFilters(selectedUserFilterId?: number) {

		this.loading = true;

		this.userFiltersService.list({
			skip: 0,
			take: null,
			filter: { logic: "and", filters: [{ field: "userFilterTypeId", operator: "eq", value: <number>UserFilterType.Activities }] }
		}).subscribe(x => {
			this.userFilters = x.data;

			if (selectedUserFilterId != null) {
				var filtered = this.userFilters.filter(x => x.userFilterId === selectedUserFilterId);

				if (filtered.length > 0) {
					this.setUserFilter(filtered[0]);
				}
			} else {
				var filtered = this.userFilters.filter(x => x.isDefault);

				if (filtered.length > 0) {
					this.setUserFilter(filtered[0]);
				} else {
					this.setLocalFilter();
				}
			}

		});
	}

	clearFilters(): void {
		this.selectedUserFilter = null;

		this.gridSettings.state = {
			skip: 0,
			take: this.gridSettings.state.take,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		};

		this.gridSettingsFilter.state = {
			skip: 0,
			take: this.gridSettings.state.take,
			sort: [{ field: 'requestIdStr', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		};

		if (this.enableSaveGridSettings) {
			this.saveGridSettings();
			this.saveGridSettings(true);
		}

		this.appService.clearAllGridFilters.next();

		this.loadData();
	}

	public ngOnInit(): void {

		this.route.queryParams
			.subscribe(params => {
				console.log('requestId', params.requestId);

				var gridSettings: GridSettings = this.persistingService.get(this.gridSettingsStorageKey);

				if (params.requestId) {
					if (gridSettings == null) {
						gridSettings = this.gridSettings;
					}

					if (gridSettings.state.filter == null) {
						gridSettings.state.filter = this.gridSettings.state.filter;
					}

					gridSettings.state.filter.filters = [];
					gridSettings.state.filter.filters.push({ field: "requestIdStr", operator: "eq", value: params.requestId });
				}

				this.setGridSettings(gridSettings);

				var gridSettingsFilter: GridSettings = this.persistingService.get(this.gridSettingsFilterStorageKey);

				if (params.requestId) {
					if (gridSettingsFilter == null) {
						gridSettingsFilter = this.gridSettingsFilter;
					}

					if (gridSettingsFilter.state.filter == null) {
						gridSettingsFilter.state.filter = this.gridSettingsFilter.state.filter;
					}

					gridSettingsFilter.state.filter.filters = [];
					gridSettingsFilter.state.filter.filters.push({ field: "requestIdStr", operator: "eq", value: params.requestId });
				}

				this.setGridSettings(gridSettingsFilter, true);

				this.onListPageInit();

				this._initUserSearchListening();

				this._initIdleService();
			});
	}

	ngAfterViewInit(): void {
		this.syncMainGridHeight();

		if (!this.filterAllInput)
			return;

		fromEvent(this.filterAllInput.nativeElement, 'keyup')
			.pipe(
				map((evt: any) => evt.target.value),
				debounceTime(500),
				distinctUntilChanged(),
			).subscribe((text: string) => this.onFilter(text));
	}

	public ngOnDestroy() {
		if (this.activityListSubscription !== null)
			this.activityListSubscription.unsubscribe();

		this._destroy$.next(true);
		this._destroy$.complete();
	}

	processListItems(items: ActivityListItem[]): void {
		this._updateRefreshTime();
	}

	public cellClick({ type, dataItem, column }: any): void {

		var activity = (<ActivityListItem>dataItem);

		if (column instanceof CheckboxColumnComponent) {

			if (this.gridSelectedRequests.some(x => x.requestId === activity.requestId)) {
				this.gridSelectedRequests = this.gridSelectedRequests.filter(x => x.requestId !== activity.requestId);
			} else {
				this.gridSelectedRequests.push(dataItem);
			}

		} else if (type === "click") {
			this.router.navigate(['/requests', activity.requestId]);
			
		}
	}

	public onContextMenuClick({ item, dataItem }: any): void {

	}

	public onRequestsReport(): void {
		this.dataGenerating = true;

		this.getXlsx('activities', 'Активности.xlsx',
			(c) => {
				c.forEach(f => {
					if (f.field === "sla") {
						f.field = "slaAsTimeSpanString";
						f.filter = "string";
					}
				});
			},
			() => {
				this.dataGenerating = false;
			});
	}


	public onFilter(inputValue: string): void {
		this.lastFilterText = inputValue;

		this.loadData(this.getCustomState(inputValue));
	}

	private getCustomState(inputValue: string): DataSourceRequestState {
		return {
			skip: 0,
			take: this.gridSettings.state.take,
			sort: this.gridSettings.state.sort,
			filter: {
				logic: "or",
				filters: [
					{
						field: 'requestIdStr',
						operator: 'eq',
						value: inputValue
					},
					{
						field: 'requestExternalId',
						operator: 'eq',
						value: inputValue
					},
					{
						field: 'statusName',
						operator: 'contains',
						value: inputValue
					},
					{
						field: 'requestServiceCenterName',
						operator: 'contains',
						value: inputValue
					},
				],
			}
		};

	}

	private _initUserSearchListening(): void {
		this._updateRefreshTime();

		const interval$ = from(interval(this._refreshTime))
			.pipe(
				filter(x => (new Date().getTime() - this._lastRefreshTime.getTime() >= this._refreshTime) && !this.loading && !this.isIdle),
				takeUntil(this._destroy$)
			);

		interval$.subscribe(() => {
			this.loadData();
		});
	}

	private _initIdleService(){
		/*this.idleService.idleMessage = 'Вы долго не проявляли активность, поэтому обновление реестра активностей приостановлено.';
		this.idleService.getIdleStatus().subscribe((isIdle) => {
			this.isIdle = isIdle;
		});*/
	}

	private _updateRefreshTime(): void {
		this._lastRefreshTime = new Date();
	}

	private _getMsTime(seconds: number): number {
		return seconds * 1000;
	}

	public initialized: boolean = false;

	setUserFilter(userFilter: UserFilter) {
		this.selectedUserFilter = userFilter;

		var localFilter = localStorage.getItem(this.gridSettingsFilterStorageKey);
		const currentTake = this.gridSettings.state.take;
		const currentSort = this.gridSettings.state.sort;

		if ((localFilter == null || localFilter != userFilter.filterExpression)) {
			var userFilterGridSettings = JSON.parse(userFilter.filterExpression);

			// Выбор фильтра меняет только грид фильтров, не настройки отображения
			this.setGridSettings(userFilterGridSettings, true);

			// Критерии фильтрации для загрузки данных; pageSize и сортировку не трогаем
			if (userFilterGridSettings.state) {
				this.gridSettings.state.filter = userFilterGridSettings.state.filter;
				this.gridSettings.state.sort = currentSort;
				this.gridSettings.state.skip = 0;
				this.gridSettings.state.take = currentTake;

				if (this.gridSettingsFilter.state) {
					this.gridSettingsFilter.state.take = currentTake;
					this.gridSettingsFilter.state.skip = 0;
					this.gridSettingsFilter.state.sort = currentSort;
				}
			}

			this.saveGridSettings(true);
			this.saveGridSettings();
		}
		
		this.loadData();

		this.initialized = true;
	}

	setLocalFilter() {
		var localFilter = this.persistingService.get<GridSettings>(this.gridSettingsStorageKey);

		if (localFilter != null) {
			this.setGridSettings(localFilter);
			this.saveGridSettings();
		}

		var localFilter2 = this.persistingService.get<GridSettings>(this.gridSettingsFilterStorageKey);

		if (localFilter2 != null) {
			this.setGridSettings(localFilter2, true);
			this.saveGridSettings(true);
		}
		
		this.loadData();

		this.initialized = true;
	}

	newFilter() {
		this.notificationService.newItemInput({ inputPlaceholder: "Введите название для нового фильтра" },
			(newFilterName) => {

				if (!!newFilterName) {
					this.userFiltersService.create({
						name: newFilterName,
						filterExpression: JSON.stringify({
							columnsConfig: this.gridSettingsFilter.columnsConfig,
							state: {
								skip: 0,
								take: this.gridSettings.state.take,
								sort: this.gridSettings.state.sort,
								filter: this.gridSettings.state.filter
							}
						}),
						isDefault: this.userFilters.length == 0,
						userFilterTypeId: <number>UserFilterType.Activities,
						userFilterId: null,
						userId: null
					}).subscribe(x => {
						this.loadUserFilters(x.data);
					})
				}
			})
	}

	userFilterSettings() {
		this.modalService.open(this.userFiltersModal, { windowClass: 'modal-top modal-sm' }).result.then((result) => {

		}, (reason) => {

		});
	}

	setUserFilterAsDefault(userFilter: UserFilter) {

		this.switchOnInProgressFlag(this.setDefaultFiltersIsInProgress, userFilter.userFilterId);

		this.userFiltersService.setDefaultUserFilter(userFilter.userFilterId).subscribe(x => {
			this.switchOffInProgressFlag(this.setDefaultFiltersIsInProgress, userFilter.userFilterId);
			this.loadUserFilters();
		});
	}

	removeUserFilter(userFilter: UserFilter) {

		this.switchOnInProgressFlag(this.removeFiltersIsInProgress, userFilter.userFilterId);

		this.userFiltersService.remove(`${userFilter.userFilterId}`, "Пользовательские фильтры", "Фильтр успешно удален").subscribe(x => {
			this.loadUserFilters();

			this.switchOffInProgressFlag(this.removeFiltersIsInProgress, userFilter.userFilterId);
		});
	}

	switchOnInProgressFlag(items: number[], id: number) {
		items.push(id);
	}

	switchMap(): void {
		if (!this.isMap && this.listViewModel.total > 1000) {
			this.notificationService.confirmation({
				title: 'Возможное снижение производительности',
				message: 'Выбрано большое 1000 заявок. Желаете продолжить?',
				type: 'question',
				confirmButtonText: 'Да',
				cancelButtonText: 'Нет',
				showCloseButton: true
			},
				() => {
					this.isMap = !this.isMap;
				},
				() => {
					this.isMapSwitcherOn = false;
				});
		} else {
			this.isMap = !this.isMap;
		}
	}

	switchOffInProgressFlag(items: number[], id: number) {
		const index = items.indexOf(id, 0);

		if (index > -1) {
			items.splice(index, 1);
		}
	}

	onScrollDown() {
		this.loading = true;
		this.gridSettings.state.skip += this.gridSettings.state.take;
		this.dataService.list(this.gridSettings.state).subscribe(lvm => {
			this.listViewModel.data = [...this.listViewModel.data, ...lvm.data];
			this.groupedData = this.groupedByKey;
			this.loading = false;
		});
	}

	public get isEngineer() {
		return this.securityService.isEngineer();
	}

	public changeSelectionTab(tab, requestStatus) {
		this.selectedTab = tab;
		this.selectedRequestStatus = requestStatus;
		this.selectedDate = 'today';
		this.filterLoad();
	}

	public isSelectedTab(tab: number) {
		return this.selectedTab === tab;
	}

	public selectDateFilter(type) {
		if (this.selectedDate === type) {
			this.selectedDate = 'all';
		} else {
			this.selectedDate = type;
		}
		this.filterLoad();
	}

	public selectDateOrder(type) {
		if (this.selectedOrder === type) {
			this.selectedOrder = null;
		} else {
			this.selectedOrder = type;
		}
		this.filterLoad();
	}

	private filterLoad() {
		this.gridSettings.state.skip = 0;
		this.gridSettings.state.filter.filters = [this.getStatusKindFilter(this.selectedDate)];
		this.gridSettings.state.sort = this.getSort()

		this.loadData();
	}

	private getSort() {
		const result = [];
		if (this.selectedOrder === 'client') {
			result.push({ field: 'customerContragentId', dir: 'asc' })
		} else if (this.selectedOrder === 'type') {
			result.push({ field: 'requestTypeId', dir: 'asc' })
		} else if (this.selectedOrder === 'address') {
			result.push({ field: 'tspAddress', dir: 'asc' })
		} else {
			result.push({ field: 'requestIdStr', dir: 'desc' });
		}

		return result;
	}

	private getStatusKindFilter(selectedDate: string): CompositeFilterDescriptor {
		const filter: CompositeFilterDescriptor = { logic: 'and', filters: [{ field: 'statusId', operator: 'eq', value: this.selectedRequestStatus }] }
		if (selectedDate === 'today') {
			const today = new Date().toJSON().split('T')
			filter.filters.push({
				logic: 'and', filters: [
					{ field: 'slaDueDate', operator: 'gte~datetime', value: `${today[0]}T00-00-0` },
					{ field: 'slaDueDate', operator: 'lte~datetime', value: `${today[0]}T00-00-0` }
				]
			})
		} else if (selectedDate === 'tomorrow') {
			const today = new Date(new Date().setHours(24)).toJSON().split('T');
			filter.filters.push({
				logic: 'and', filters: [
					{ field: 'slaDueDate', operator: 'gte~datetime', value: `${today[0]}T00-00-0` },
					{ field: 'slaDueDate', operator: 'lte~datetime', value: `${today[0]}T00-00-0` }
				]
			})
		} else if (selectedDate !== 'all') {
			const today = new Date();
			const s = selectedDate.split('.');
			filter.filters.push({
				logic: 'and', filters: [
					{ field: 'slaDueDate', operator: 'gte~datetime', value: `${today.getFullYear()}-${this.getDate(s[1])}-${this.getDate(s[0])}T00-00-0` },
					{ field: 'slaDueDate', operator: 'lte~datetime', value: `${today.getFullYear()}-${this.getDate(s[1])}-${this.getDate(s[0])}T00-00-0` }
				]
			})
		}
		return filter;
	}

	private getDate(s) {
		return s.length < 2 ? "0" + s : s;
	}

	trackByFunction(index, item: ColumnSettings) {

		if (!item)
			return null;

		return item.field;
	}

	public toggleAccordion(any) {
		if (this.toggledAccordions[any.index] !== undefined && this.toggledAccordions[any.index] !== null) {
			this.toggledAccordions[any.index] = any.active;
		} else {
			this.toggledAccordions.set(any.index, any.active);
		}
	}

	public isActiveAccordion(index: number) {
		return this.alwaysToggled || this.toggledAccordions[index];
	}

	public alwaysToggledChange() {
		this.alwaysToggled = !this.alwaysToggled;
		localStorage.setItem('alwaysToggled', this.alwaysToggled.toString());
	}

	get hasAddRequestClaim(): boolean {
		return this.securityService.hasClaim('cat-requests-add');
	}

	public onVisibilityChange(event: ColumnVisibilityChangeEvent, isFilter: boolean = false): void {
		if (!this.enableSaveGridSettings) {
			return;
		}

		this.actualizeHiddenColumnsFilteringAndSorting(event.columns);
		super.onVisibilityChange(event, isFilter);
		this.loadData();
	}

	getDateString(dataItem: ActivityListItem, column: ColumnSettings): string {
		var localDateFieldName = column.field.replace("Moscow", "Local");
		var localDate = dataItem[localDateFieldName];

		if (localDate == null)
			return "";

		var formattedDate = this.intl.formatDate(this.intl.parseDate(localDate), column.format);

		return `${formattedDate} ${dataItem["requestUtcTimezoneShiftString"]}`;
	}
}
